// extracted by mini-css-extract-plugin
export default {"container":"HighContrastButton_container__JlBh9","active":"HighContrastButton_active__KrnAM"};